/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UndercarriageFleetComponentSnapshotResponse } from './UndercarriageFleetComponentSnapshotResponse';
import {
    UndercarriageFleetComponentSnapshotResponseFromJSON,
    UndercarriageFleetComponentSnapshotResponseFromJSONTyped,
    UndercarriageFleetComponentSnapshotResponseToJSON,
    UndercarriageFleetComponentSnapshotResponseToJSONTyped,
} from './UndercarriageFleetComponentSnapshotResponse';

/**
 * 
 * @export
 * @interface UndercarriageFleetSnapshotResponse
 */
export interface UndercarriageFleetSnapshotResponse {
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    assetId?: number;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    assetName?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    assetTypeName?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    siteName?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    customerId?: number;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    customerName?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    region?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    commodity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    machineModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    machineManufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    undercarriageManufacturer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    inspectionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    lastInspectionId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    lastInspectionDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    firstInspectionDate?: Date | null;
    /**
     * 
     * @type {Array<Date>}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    inspectionDates?: Array<Date>;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    totalMachineHours?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    undercarriageHoursLeft?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    undercarriageHoursRight?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    assumedFactoryFittedLeft?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    assumedFactoryFittedRight?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    utilisationHoursPerDay?: number | null;
    /**
     * 
     * @type {Array<UndercarriageFleetComponentSnapshotResponse>}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    components?: Array<UndercarriageFleetComponentSnapshotResponse>;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    missingMachineHoursCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    changeoutMissingDateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    changeoutMissingHoursCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    changeoutRestatementCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSnapshotResponse
     */
    changeoutImportSignatureCount?: number;
}

/**
 * Check if a given object implements the UndercarriageFleetSnapshotResponse interface.
 */
export function instanceOfUndercarriageFleetSnapshotResponse(value: object): value is UndercarriageFleetSnapshotResponse {
    return true;
}

export function UndercarriageFleetSnapshotResponseFromJSON(json: any): UndercarriageFleetSnapshotResponse {
    return UndercarriageFleetSnapshotResponseFromJSONTyped(json, false);
}

export function UndercarriageFleetSnapshotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageFleetSnapshotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'assetName': json['assetName'] == null ? undefined : json['assetName'],
        'assetTypeName': json['assetTypeName'] == null ? undefined : json['assetTypeName'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'region': json['region'] == null ? undefined : json['region'],
        'commodity': json['commodity'] == null ? undefined : json['commodity'],
        'machineModel': json['machineModel'] == null ? undefined : json['machineModel'],
        'machineManufacturer': json['machineManufacturer'] == null ? undefined : json['machineManufacturer'],
        'undercarriageManufacturer': json['undercarriageManufacturer'] == null ? undefined : json['undercarriageManufacturer'],
        'inspectionCount': json['inspectionCount'] == null ? undefined : json['inspectionCount'],
        'lastInspectionId': json['lastInspectionId'] == null ? undefined : json['lastInspectionId'],
        'lastInspectionDate': json['lastInspectionDate'] == null ? undefined : (new Date(json['lastInspectionDate'])),
        'firstInspectionDate': json['firstInspectionDate'] == null ? undefined : (new Date(json['firstInspectionDate'])),
        'inspectionDates': json['inspectionDates'] == null ? undefined : json['inspectionDates'],
        'totalMachineHours': json['totalMachineHours'] == null ? undefined : json['totalMachineHours'],
        'undercarriageHoursLeft': json['undercarriageHoursLeft'] == null ? undefined : json['undercarriageHoursLeft'],
        'undercarriageHoursRight': json['undercarriageHoursRight'] == null ? undefined : json['undercarriageHoursRight'],
        'assumedFactoryFittedLeft': json['assumedFactoryFittedLeft'] == null ? undefined : json['assumedFactoryFittedLeft'],
        'assumedFactoryFittedRight': json['assumedFactoryFittedRight'] == null ? undefined : json['assumedFactoryFittedRight'],
        'utilisationHoursPerDay': json['utilisationHoursPerDay'] == null ? undefined : json['utilisationHoursPerDay'],
        'components': json['components'] == null ? undefined : ((json['components'] as Array<any>).map(UndercarriageFleetComponentSnapshotResponseFromJSON)),
        'missingMachineHoursCount': json['missingMachineHoursCount'] == null ? undefined : json['missingMachineHoursCount'],
        'changeoutMissingDateCount': json['changeoutMissingDateCount'] == null ? undefined : json['changeoutMissingDateCount'],
        'changeoutMissingHoursCount': json['changeoutMissingHoursCount'] == null ? undefined : json['changeoutMissingHoursCount'],
        'changeoutRestatementCount': json['changeoutRestatementCount'] == null ? undefined : json['changeoutRestatementCount'],
        'changeoutImportSignatureCount': json['changeoutImportSignatureCount'] == null ? undefined : json['changeoutImportSignatureCount'],
    };
}

export function UndercarriageFleetSnapshotResponseToJSON(json: any): UndercarriageFleetSnapshotResponse {
    return UndercarriageFleetSnapshotResponseToJSONTyped(json, false);
}

export function UndercarriageFleetSnapshotResponseToJSONTyped(value?: UndercarriageFleetSnapshotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetId': value['assetId'],
        'assetName': value['assetName'],
        'assetTypeName': value['assetTypeName'],
        'siteId': value['siteId'],
        'siteName': value['siteName'],
        'customerId': value['customerId'],
        'customerName': value['customerName'],
        'region': value['region'],
        'commodity': value['commodity'],
        'machineModel': value['machineModel'],
        'machineManufacturer': value['machineManufacturer'],
        'undercarriageManufacturer': value['undercarriageManufacturer'],
        'inspectionCount': value['inspectionCount'],
        'lastInspectionId': value['lastInspectionId'],
        'lastInspectionDate': value['lastInspectionDate'] === null ? null : ((value['lastInspectionDate'] as any)?.toISOString()),
        'firstInspectionDate': value['firstInspectionDate'] === null ? null : ((value['firstInspectionDate'] as any)?.toISOString()),
        'inspectionDates': value['inspectionDates'],
        'totalMachineHours': value['totalMachineHours'],
        'undercarriageHoursLeft': value['undercarriageHoursLeft'],
        'undercarriageHoursRight': value['undercarriageHoursRight'],
        'assumedFactoryFittedLeft': value['assumedFactoryFittedLeft'],
        'assumedFactoryFittedRight': value['assumedFactoryFittedRight'],
        'utilisationHoursPerDay': value['utilisationHoursPerDay'],
        'components': value['components'] == null ? undefined : ((value['components'] as Array<any>).map(UndercarriageFleetComponentSnapshotResponseToJSON)),
        'missingMachineHoursCount': value['missingMachineHoursCount'],
        'changeoutMissingDateCount': value['changeoutMissingDateCount'],
        'changeoutMissingHoursCount': value['changeoutMissingHoursCount'],
        'changeoutRestatementCount': value['changeoutRestatementCount'],
        'changeoutImportSignatureCount': value['changeoutImportSignatureCount'],
    };
}

